export default "__VITE_ASSET__hrGI0IWb__"